<template>
  <v-menu
    open-on-click
    open-delay="0"
    v-if="displayMode==='menu'"
  >
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        variant="tonal"
        color="primary" prepend-icon="mdi-forum" append-icon="mdi-menu-right"
      >
        {{ text ? text : 'Visit support spaces' }}
      </v-btn>
    </template>
    <v-list>
      <template
        v-for="space in spaces"
        :key="space.name"
      >
        <v-list-item
          :href="space.url"
          target="_blank"
        >
          <template #prepend>
            <template v-if="space.icon && space.icon.startsWith('ws-icon-')">
              <ws-icon :icon="space.icon" />
            </template>
            <template v-else>
              <v-icon>{{ space.icon }}</v-icon>
            </template>
          </template>
          {{ space.name }}
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
  <template v-else>
    <div
      :class="headerClass?headerClass:'text-h5'"
      v-if="!isHeaderHidden"
    >
      Visit support spaces
    </div>
    <v-row class="mt-4">
      <template
        v-for="space in spaces"
        :key="space.name"
      >
        <v-btn
          :color="linksColor?linksColor:'primary'"
          :href="space.url"
          target="_blank"
          variant="text"
          :size="linksSize?linksSize:'x-large'"
        >
          <template #prepend>
            <template v-if="space.icon && space.icon.startsWith('ws-icon-')">
              <ws-icon :icon="space.icon" />
            </template>
            <template v-else>
              <v-icon>{{ space.icon }}</v-icon>
            </template>
          </template>
          {{ space.name }}
        </v-btn>
      </template>
    </v-row>
  </template>
</template>
<script setup lang="ts">
import wsIcon from '~/components/ws-icon.vue'

const props = defineProps<{
  displayMode?: 'menu' | 'list';
  isHeaderHidden?: boolean;
  headerClass?: string;
  linksSize?: string;
  linksColor?: string;
  text?: string;
  youtube?: boolean;
  hideContacts?: boolean;
}>();
const displayMode = props.displayMode || 'menu';
const spaces = [
  {
    name: 'Telegram',
    url: 'https://t.me/wiresock',
    icon: 'ws-icon-telegram',
    // icon: 'mdi-message-bulleted',
  },
  {
    name: 'Discord',
    url: 'https://discord.gg/hMNttJ7CMX',
    icon: 'ws-icon-discord',
  },
  {
    name: 'GitHub',
    url: 'https://github.com/wiresock',
    icon: 'mdi-github',
  },
];

if (props.youtube) {
  spaces.push({
    name: 'YouTube',
    url: 'https://www.youtube.com/@WireSock/videos',
    icon: 'mdi-youtube',
  });
}
if (!props.hideContacts) {
  spaces.push({
    name: 'Contact us',
    url: 'https://wiresock.net/about/contacts',
    icon: 'mdi-email',
  });
}
</script>
